import type { ReactNode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { env } from '@/shared/lib/env';

type Props = {
  children: ReactNode;
};

export const AuthGoogleProvider = ({ children }: Props) => {
  if (!env.googleClientId) return <>{children}</>;
  return <GoogleOAuthProvider clientId={env.googleClientId}>{children}</GoogleOAuthProvider>;
};
